'use client'

import { DialogTitle } from '@headlessui/react'
import {
  PageHeaderTitle,
  type PageHeaderTitleProps,
} from '../../../headers/page-header/page-header-title.tsx'

export type ModalOverlineHeaderTitleProps = PageHeaderTitleProps

export const ModalOverlineHeaderTitle = (
  props: ModalOverlineHeaderTitleProps
) => {
  return <DialogTitle as={PageHeaderTitle} {...props} />
}
